import { render, staticRenderFns } from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=template&id=db3b2d08&scoped=true"
import script from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=script&lang=js"
export * from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=script&lang=js"
import style0 from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=style&index=0&id=db3b2d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3b2d08",
  null
  
)

export default component.exports